/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetOfferViews401Response { 
    error_key?: GetOfferViews401Response.ErrorKeyEnum;
}
export namespace GetOfferViews401Response {
    export type ErrorKeyEnum = 'authorization.invalid';
    export const ErrorKeyEnum = {
        AuthorizationInvalid: 'authorization.invalid' as ErrorKeyEnum
    };
}


